/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'barbaric',
    quality: 0.2,
    learning: -2,
    strength: 2,
    damageMod: 0.1
}